import * as ActionTypes from '../ActionTypes';

const initialState = {
    empAdminLoading: false,
    adminExitEmployeeData: [],
    error: null,
};

export const ECMSAdminActionReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.ECMS_ADMIN_EXIT_EMPLOYEE_GET_REQUEST:
            return {
                ...state,
                empAdminLoading: true,
                adminExitEmployeeData: [],
                error: null,
            };
        case ActionTypes.ECMS_ADMIN_EXIT_EMPLOYEE_GET_SUCCESS:
            return {
                ...state,
                empAdminLoading: false,
                adminExitEmployeeData: action.payload?.data?.data || [],
                error: null,
            };

        case ActionTypes.ECMS_ADMIN_EXIT_EMPLOYEE_GET_ERROR:
            return {
                ...state,
                empAdminLoading: false,
                error: true,
            };

        default:
            return state;
    }
};
